import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../CartProvider';
import './CheckoutSummary.css'; 

export function CheckoutSummary() {
  const navigate = useNavigate();
  const { cart, dispatch, shippingAddress, setShippingAddress, billingAddress, setBillingAddress, mailAddress, setMailAddress } = useContext(CartContext);
  const [productDetails, setProductDetails] = useState(null);
  const [totalPrice, setTotalPrice] = useState(null);
  const [deliveryCosts, setDeliveryCosts] = useState(null);
  const [deliveryTime, setDeliveryTime] = useState(null);
  const [isAgbAccepted, setIsAgbAccepted] = useState(false);

  useEffect(() => {
    loadProducts();
  }, []);

  const handleAgbAcceptedChange = (event) => {
    setIsAgbAccepted(event.target.checked);
  };

  const loadProducts = () => {
    // Prepare the cart data
    const cartData = cart.map(item => ({ key: item.id, value: item.quantity }));

    // Fetch product details
    fetch('api/Product/GetProductDetails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(data => 
      {
        setProductDetails(data.products);
        setTotalPrice(data.totalPrice);
        setDeliveryCosts(data.deliveryCost);
        setDeliveryTime(data.deliveryTime);
      });
  }

  const handleGoToPayment = async () => {
    // Prepare the cart data
    const cartData = cart.map(item => ({ key: item.id, value: item.quantity }));

    const request = {
      cart: cartData,
      billingAddress: billingAddress,
      shippingAddress: shippingAddress,
      mailAddress: mailAddress
    }
    // Fetch product details
    await fetch('api/Checkout/InitiateOrderPayment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    })
    .then(response => response.json()) // Parse the JSON response
    .then(data => {
      const pUrl = data.paymentUrl;
      window.location.href = pUrl;
    });
  }

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <div className="checkout-summary" style={{ marginBottom: '60px' }}>
      <h1 style={{ marginBottom: '40px' }}>Zusammenfassung</h1>
      <div className="address-container" style={{ marginBottom: '40px' }}>
        <div className="address-section">
          <strong>Lieferadresse</strong>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '14px', color: '#5A5A5A', lineHeight: 1.7 }}>
            <div>{mailAddress}</div>
            <br />
            <div>{shippingAddress.firstName} {shippingAddress.lastName}</div>
            {shippingAddress.companyName && <div>{shippingAddress.companyName}</div>}
            <div>{shippingAddress.addressLine1}</div>
            <div>{shippingAddress.zip} {shippingAddress.city}</div>
            <div>{shippingAddress.country}</div>
          </div>
        </div>
        {billingAddress && <div className="address-section">
          <strong>Rechnungsadresse</strong>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '14px', color: '#5A5A5A', lineHeight: 1.7 }}>
            <div>{billingAddress.firstName} {billingAddress.lastName}</div>
            {billingAddress.companyName && <div>{billingAddress.companyName}</div>}
            <div>{billingAddress.addressLine1}</div>
            <div>{billingAddress.zip} {shippingAddress.city}</div>
            <div>{billingAddress.country}</div>
          </div>
        </div>}
      </div>
      <div className="product-details-container">
          {productDetails && productDetails.map((productDetail) => (
              <div key={productDetail.identifier} className="product-detail-item">
                  <img src={productDetail.image} alt={productDetail.name} className="product-imagesc" />
                  <p className="product-item-name">{productDetail.name}</p>
                  <p className="product-unit-price">{productDetail.unitPrice}</p>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', margin: 0 }}>× {productDetail.quantity}</p>
                  <p className="product-total-price">{productDetail.totalPrice}</p>
              </div>
          ))}
      </div>
      <div style={{ marginBottom: '24px' }}>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: '#868686', textAlign: 'right', margin: '8px 0' }}>{deliveryCosts}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '13px', color: '#868686', textAlign: 'right', margin: '8px 0' }}>{deliveryTime}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '16px', fontWeight: 600, color: '#5A5A5A', textAlign: 'right', margin: '12px 0 4px' }}>Gesamtpreis*: {totalPrice}</p>
        <p style={{ fontFamily: "'Inter', sans-serif", textAlign: 'right', fontSize: '11px', color: '#B0ADA7' }}>* Umsatzsteuer wird nicht erhoben gemäß §19UStG</p>
      </div>
      <div style={{ marginTop: '20px', marginBottom: '28px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <input id="inputConsent" type="checkbox" checked={isAgbAccepted} onChange={handleAgbAcceptedChange} />
        <label htmlFor="inputConsent" style={{ margin: 0, fontFamily: "'Inter', sans-serif", fontSize: '13px', textTransform: 'none', letterSpacing: 0, fontWeight: 400, color: '#5A5A5A', cursor: 'pointer' }}>
          Ich habe die <a href="/agb" target="_blank" rel="noopener noreferrer">AGBs</a> und <a href="/privacy" target="_blank" rel="noopener noreferrer">Datenschutzbestimmungen</a> gelesen und akzeptiere sie.
        </label>
      </div>
      <div style={{ marginTop: '16px', marginBottom: '60px', display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <button className="global-button-white" onClick={handleBack} style={{ width: '180px' }}>Zurück</button>
        <button className="global-button" onClick={handleGoToPayment} disabled={!isAgbAccepted} style={{ width: '200px' }}>Kaufen</button>
      </div>
    </div>
  );
}
